import { IMapService } from "./IMapService";
import { MapboxMapService } from "./MapboxMapService";
import { MockMapService } from "./MockMapService";
import { RouteManager } from "./RouteManager";
import { MapEventBus } from "./MapEventBus";
import mapboxgl from "mapbox-gl";

export interface Services {
  mapService: IMapService;
  routeManager: RouteManager;
  eventBus: MapEventBus;
}

export class ServiceProvider {
  private static instance: ServiceProvider;
  private services: Services | null = null;
  
  private constructor() {}
  
  static getInstance(): ServiceProvider {
    if (!ServiceProvider.instance) {
      ServiceProvider.instance = new ServiceProvider();
    }
    return ServiceProvider.instance;
  }
  
  /**
   * Initialize services for production use
   */
  initializeProduction(map: mapboxgl.Map, layerRegistry: any): Services {
    this.services = {
      mapService: new MapboxMapService(map, layerRegistry),
      routeManager: new RouteManager(),
      eventBus: MapEventBus.getInstance()
    };
    
    return this.services;
  }
  
  /**
   * Initialize services for testing
   */
  initializeTesting(): Services {
    this.services = {
      mapService: new MockMapService(),
      routeManager: new RouteManager(),
      eventBus: MapEventBus.getInstance()
    };
    
    return this.services;
  }
  
  /**
   * Get the current services
   */
  getServices(): Services {
    if (!this.services) {
      throw new Error("Services not initialized. Call initializeProduction or initializeTesting first.");
    }
    return this.services;
  }
  
  /**
   * Get individual service
   */
  getMapService(): IMapService {
    return this.getServices().mapService;
  }
  
  getRouteManager(): RouteManager {
    return this.getServices().routeManager;
  }
  
  getEventBus(): MapEventBus {
    return this.getServices().eventBus;
  }
  
  /**
   * Clear all services (useful for testing)
   */
  clear(): void {
    if (this.services) {
      this.services.eventBus.clear();
      this.services = null;
    }
  }
}